<template>
  <vs-row vs-align="center" class="my-1">
    <vs-col vs-w="2">
      <vs-row vs-justify="flex-end" vs-align="center" class="pr-4">
        <span>{{ title }}</span>
      </vs-row>
    </vs-col>
    <vs-col vs-w="10">
      <slot></slot>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: ["title"],
};
</script>
